import React from 'react';
import './region-popover-content.scss';
import getCountryFlag from '../../../../utils/countries-flags';
import { SystemConfiguration } from '../../../../utils/system-configuration';

interface RegionPopoverProps {
    regions: string[];
}

export const RegionPopoverContent: React.FC<RegionPopoverProps> = ({regions}) => {
    const regionsByName = SystemConfiguration.getInstance().getCountriesMapByName;


    const getFlag = (countryCode: string) => {
        const FlagSvg = getCountryFlag(countryCode);
        return <div className="flag">{FlagSvg && <FlagSvg />}</div>;
    };

    return (
        <div className="expanded-popover">
            {regions
                .slice()
                .sort((a, b) => a.localeCompare(b))
                .map(region => (
                    <div className="flag-and-name" key={region}>
                        {getFlag(regionsByName[region]?.countryCode)}
                        <div className="country-name">{region}</div>
                    </div>
                ))}
        </div>
    );
};